'use es6';

import { getProductBasedOfferIdsWithMandatorySku } from 'pricing-pages-lib/utils/productBasedOfferUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const productBasedOfferIdsWithMandatorySkuSelector = createSelectorFromUtil(getProductBasedOfferIdsWithMandatorySku, transformState);